import CodeDiff from "v-code-diff";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(CodeDiff);
});


export interface diffTable {
  key: string;
  oldValue: any;
  newValue: any;
  changed: boolean;
}

export function flattenObject(obj: any, prefix = ''): Record<string, any> {
  const result: Record<string, any> = {};
  if (obj === null || typeof obj !== 'object') return result;

  for (const key in obj) {
    const value = obj[key];
    const newKey = prefix ? `${prefix}.${key}` : key;
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(result, flattenObject(value, newKey));
    } else {
      result[newKey] = value;
    }
  }
  return result;
}
export function diffRows(
  oldJson: string,
  newJson: string,
  excludedKeys: string[] = []
): diffTable[] {
  try {
    const oldFlat = flattenObject(JSON.parse(oldJson ?? '{}'));
    const newFlat = flattenObject(JSON.parse(newJson ?? '{}'));
    const allKeys = [...new Set([...Object.keys(oldFlat), ...Object.keys(newFlat)])];

    return allKeys
      .filter((key) => {
        return !excludedKeys.some(
          (excluded) => key === excluded || key.startsWith(excluded + '.')
        );
      })
      .map((key) => ({
        key,
        oldValue: oldFlat[key],
        newValue: newFlat[key],
        changed: JSON.stringify(oldFlat[key]) !== JSON.stringify(newFlat[key]),
      }));
  } catch (e) {
    console.error('Error parsing diff:', e);
    return [];
  }
}
